<script setup lang="ts">
import type { CmsElementZebraCmsHeroSlider } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsHeroSlider;
}>();

import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const settings = {
  itemsToShow: 1,
  snapAlign: 'start',
  autoplay: 6000,
  transition: 600,
  pauseAutoplayOnHover: true,
};

const heroSlider = ref(null)
const currentSlide = ref(null)

const slideTo = (val) => {
  currentSlide.value = val;
};

const { Slides } = props.content?.config;

const replaceDomain = (link: any) => {
  if (!link) {
    return link;
  }
  link = link.replace("https://zebra-fashion-preview.vercel.app/fr/", "/");
  link = link.replace("https://zebra-fashion-preview.vercel.app/", "/");
  link = link.replace("https://www.zebrafashion.com/fr-FR/", "/");
  link = link.replace("https://www.zebrafashion.com/", "/");
  return link;
};
</script>
<template>
  <div class="hero-section relative" v-if="Slides.value">
    <h1
      v-if="Slides.value && Slides.value[0]"
      class="text-[40px] md:text-5xl lg:text-6xl mb-5 font-bold hidden"
    >
      {{ Slides.value[0].sliderHeadlineText }}
    </h1>
    <div class="hero-slider m-0">

      <Carousel
        v-if="Slides.value && Slides.value.length > 1"
        v-bind="settings"
        ref="heroSlider"
        v-model="currentSlide"
      >
        <template v-for="(slide, index) in Slides.value" :key="slide">
          <Slide>
            <NuxtLink
              v-if="slide.fulllink?.url"
              class="w-full"
              :target="slide.fulllink?.target"
              :to="formatLink(replaceDomain(slide.fulllink?.url))"
            >
              <CmsHeroSlideItem :slide="slide" :index="index" />
            </NuxtLink>
            <template v-else>
              <CmsHeroSlideItem :slide="slide" :index="index"
            /></template>
          </Slide>
        </template>
      </Carousel>

      <template
        v-if="Slides.value && Slides.value[0] && Slides.value.length == 1"
      >
        <NuxtLink
          v-if="Slides.value[0]?.fulllink?.url"
          class="w-full"
          :target="Slides.value[0]?.fulllink?.target"
          :to="formatLink(replaceDomain(Slides.value[0]?.fulllink?.url))"
        >
          <CmsHeroSlideItem :slide="Slides.value[0]" :index="0" />
        </NuxtLink>
        <template v-else>
          <CmsHeroSlideItem :slide="Slides.value[0]" :index="0" />
        </template>
      </template>

      <ul
        class="slick-dots"
        role="tablist"
        style=""
        v-if="Slides.value && Slides.value[0] && Slides.value.length > 1"
      >
        <template v-for="(slide, index) in Slides.value">
          <li
            :class="{ 'slick-active': currentSlide == index }"
            role="presentation"
            @click="slideTo(index)"
          >
            &nbsp;
          </li>
        </template>
      </ul>

    </div>
  </div>
</template>
